import { Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, TouchableOpacity, SafeAreaView, View, ScrollView } from 'react-native';
import { AppUser } from '../../models';
import { SaveDialog } from "../components/CmnDiaLog";
import { getCurrentUser } from '../components/CmnUtil';
import { allRemoveStorage } from '../components/SessionStorage';

/** ================================
*  設定トップ画面
*  ================================*/
const SettingTop = ({ navigation }: { navigation: any; }) => {

  // ログアウト確認ダイアログフラグ
  const [logoutDialogFlag, setLogoutDialogFlag] = useState<boolean>(false);

  const [userType, setUserType] = useState<string>("");

  useEffect(() => {
    (async () => {
      const appUser: AppUser | undefined = await getCurrentUser();
      const userType: string = typeof appUser === "undefined" ?
        ""
        :
        appUser.type;

      setUserType(userType);
    })();
  }, []);

  // 組織情報変更ボタン クリック
  const onClickGroupInfoUpdate = () => {
    navigation.navigate('GroupInfoUpdate');
  };

  // ユーザー情報変更ボタン クリック
  const onClickUserInfoUpdate = () => {
    navigation.navigate('UserInfoUpdate');
  };

  // パスワード変更ボタン クリック
  const onClickUserPasswordUpdate = () => {
    navigation.navigate('UserPasswordUpdate');
  };

  // 圃場管理ボタン クリック
  const onClickFarmList = () => {
    navigation.navigate('FarmList');
  };

  // ログアウトボタン クリック
  const onClickLogout = () => {
    setLogoutDialogFlag(false);
    signOut();
  };

  /**
   * ログアウト処理
   */
  const signOut = async () => {
    await Auth.signOut().then(() => {
      allRemoveStorage();
    }).catch(error => {
      console.error('error signing out: ', error);
    }).finally(() => {
      document.location.reload();
    });
  };

  return (
    <SafeAreaView style={styles.container}>

      {!logoutDialogFlag &&
        <ScrollView>
          <View style={styles.wrapper}>
            <TouchableOpacity style={styles.settingBody} onPress={onClickGroupInfoUpdate}>
              <Text style={styles.settingBodyText}>組織情報変更</Text>
            </TouchableOpacity>

            <TouchableOpacity style={styles.settingBody} onPress={onClickUserInfoUpdate}>
              <Text style={styles.settingBodyText}>ユーザー情報変更</Text>
            </TouchableOpacity>

            <TouchableOpacity style={styles.settingBody} onPress={onClickUserPasswordUpdate}>
              <Text style={styles.settingBodyText}>パスワード変更</Text>
            </TouchableOpacity>

            {userType == "Producer" &&
              <TouchableOpacity style={styles.settingBody} onPress={onClickFarmList}>
                <Text style={styles.settingBodyText}>圃場管理</Text>
              </TouchableOpacity>
            }

            <TouchableOpacity style={[styles.settingBody, { marginTop: 50, height: 60, }]} onPress={() => setLogoutDialogFlag(true)}>
              <Text style={styles.settingBodyText}>ログアウト</Text>
            </TouchableOpacity>
          </View></ScrollView>
      }
      <SaveDialog
        saveButtonName={"ログアウト"}
        cancelButtonName={"キャンセル"}
        saveAction={onClickLogout}
        canceAction={() => setLogoutDialogFlag(false)}
        message={"ログアウトします。\nよろしいですか？"}
        visible={logoutDialogFlag}
      />

    </SafeAreaView>

  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#e8f4dc',
  },
  wrapper: {
    flex: 1,
    alignItems: "center",
    paddingTop: 25,
    width: "100%",
  },
  settingBody: {
    backgroundColor: "#70AD47",
    width: "75%",
    height: 70,
    marginBottom: 25,
    shadowColor: "#808080",
    shadowOffset: { width: 5, height: 5 },
    shadowRadius: 10,
    borderColor: "#507E32",
    borderStyle: "solid",
    borderWidth: 2,
    alignItems: "center",
    justifyContent: "center",
  },
  settingBodyText: {
    color: "#ffffff",
    fontSize: 27,
    textAlign: "center",
    justifyContent: "center",
  },
});

export default SettingTop;